import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Button, Fade } from "react-bootstrap";

import Icon from '@components/custom/Icon';

class Table extends Component {
  state = {
    sortBy: "",
    sortDirection: "DESC",
    openRows: [],
    expandAllRows: false
  };

  componentDidMount() {
    const { data, defaultSortBy, expandAllRows } = this.props;
    if (defaultSortBy) {
      this.setState({
        sortBy: defaultSortBy,
        ...(expandAllRows && { openRows: data.map((_, index) => index) }),
      });
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.expandAllRows || nextProps.expandAllRows !== this.props.expandAllRows) {
      this.setState({
        openRows: nextProps.expandAllRows ? nextProps.data.map((_, index) => index) : [],
      });
    }
  }

  onSortClick = (field) => {
    let { sortDirection } = this.state;

    const sortBy = field;
    if (sortDirection === "DESC") {
      sortDirection = "ASC";
    } else {
      sortDirection = "DESC";
    }

    this.setState({
      sortBy,
      sortDirection
    });
  };

  sortedData = (data) => {
    const { columns } = this.props;
    const { sortBy, sortDirection } = this.state;
    if (!sortBy) {
      return data;
    }

    const filteredData = data.filter(elem => !elem.isTotal);
    const sortedByColumn = columns.find(column => column.value === sortBy);

    const getNumber = (element) => {
      const numberPattern = /\d+(\.\d+)?$/g;
      if (typeof element === "number") {
        return element;
      }

      const foundNumbers = element.replace(/,/g, "").match(numberPattern);
      return foundNumbers && foundNumbers.length ? parseFloat(foundNumbers[0]) : '';
    };

    filteredData.sort((elemA, elemB) => {
      const propertyA = sortedByColumn.isNumber ? getNumber(elemA[sortBy]) : elemA[sortBy];
      const propertyB = sortedByColumn.isNumber ? getNumber(elemB[sortBy]) : elemB[sortBy];

      if (propertyA > propertyB) {
        return sortDirection === "ASC" ? 1 : -1;
      } else if (propertyA < propertyB) {
        return sortDirection === "ASC" ? -1 : 1;
      }

      return 0;
    });

    return filteredData.concat(data.filter(elem => elem.isTotal));
  };

  onTableRowClick = (rowIndex) => {
    const { openRows } = this.state;

    if (openRows.includes(rowIndex)) {
      this.setState({
        openRows: openRows.filter(row => row !== rowIndex)
      });
      return;
    }
    
    this.setState({
      openRows: openRows.concat(rowIndex)
    });
  };

  render() {
    const { alwaysClick, openRows, sortBy } = this.state;
    const { columns, data, isStriped, className, disableSort, filters } = this.props;

    const rows = this.sortedData(data);

    if (!columns || !data) {
      return <div><span/></div>;
    }

    return (
      <div className={ `table-component ${className}` }>
        <table className={ `table ${isStriped ? "table-striped" : ""}` }>
          <thead>
            <tr>
              {columns.map(column => {
                const isFilterActive = filters && filters[column.id]?.length > 0 && filters[column.id][0] !== '-1';
                return (
                  <th
                    key={ column.value + column.label }
                    style={ { pointerEvents: column.isAction ? "none" : "", width: column.width ? column.width : "",
                      textAlign: column.rightAligned ? 'right' : column.centerAligned ? 'center' : '',} }
                    className={ `th-${column.value} ${sortBy === column.value ? 'header-active' : ''}` }
                    { ...(!disableSort && { onClick: () => this.onSortClick(column.value) }) }
                  >
                    <span className={ `text-span ${isFilterActive ? 'filter-active' : ''}` } >
                      {isFilterActive && <Icon name='filter_alt' size={ 20 } /> }
                      { column.label }
                    </span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {rows.map((dataElem, index) => {
              let childRows = [];
              if (dataElem.childNodes && (dataElem.childNodes.length > 1 || alwaysClick)) {
                childRows = this.sortedData(dataElem.childNodes).map((child, childIndex) => {
                  const idx = 'child-' + childIndex;
                  return (
                    <Fade key={ idx } in={ openRows.includes(index) }>
                      <tr
                        className={ `child-row ${ openRows.includes(index) ? "visible" : "hidden-row" } ${ childIndex & 1 ? "even" : "odd" }` }>
                        { columns.map(column => {
                          return (
                            <td
                              key={ column.value + idx + column.label }
                              style={ { textAlign: column.rightAligned ? 'right' : column.centerAligned ? 'center' : '' } }
                            >
                              { child[column.value] }
                            </td>
                          );
                        }) }
                      </tr>
                    </Fade>
                  );
                });
              }
              return (
                <Fragment key={ index }>
                  <tr
                    key={ index }
                    className={ `${ index & 1 ? "even" : "odd" } parent-row ${ dataElem.childNodes && dataElem.childNodes.length <= 1 && !alwaysClick ? 'grey' : '' } ${ openRows.includes(index) ? "opened-row" : "" } ${ dataElem.isDisabledRow ? 'row-disabled' : '' } ${ dataElem.rowClassName || '' } ${ dataElem.rowClassName || '' }` }
                    { ...(dataElem.childNodes && dataElem.childNodes.length > 0 && ({ onClick: () => this.onTableRowClick(index) })) }
                  >
                    {columns.map(column => {
                      const value = dataElem[column.value];

                      return (
                        <td
                          key={ 'td-inner' + column.value + index + column.label }
                          style={ { textAlign: column.rightAligned ? 'right' : column.centerAligned ? 'center' : ''} }
                          className={ dataElem.disabledRow ? 'disabled' : ''  }
                        >
                          {column.isAction ? (
                            <NavLink to={ `${column.route}/${value}` } className={ column.className }>
                              { column.label }
                            </NavLink>
                          ) : column.isButton ? (
                            <Button
                              className={ column.className }
                              onClick={ () => column.triggerEvent(dataElem) }>
                              { column.label }
                            </Button>
                          ) : value
                          }
                        </td>
                      );}
                    )}
                  </tr>
                  { childRows }
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Table;
